export default {
    getTeamProfile(state) {
        return state.teamProfile;
    },

    isFinale(state) {
        return state.isFinale;
    },
}